var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 9,
    y: 9,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#5FD0FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2887 12.7851L17.5 5.70339M17.5 5.70339V9.23498M17.5 5.70339H13.9695M10.2512 5.5H5.5C5.5 10.1863 5.5 12.8137 5.5 17.5C10.1863 17.5 12.8137 17.5 17.5 17.5C17.5 15.6587 17.5 14.6264 17.5 12.7851",
    stroke: "#00212E",
    strokeWidth: 0.897511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.0de44a5dd00e16807b1438a05a1904cc.svg";
export { ForwardRef as ReactComponent };